import { AdminAppState, PlacesState } from '../../state';

export const getPlaces = (state: AdminAppState): PlacesState => state.places;
